import React, { useEffect, useMemo, useRef, useState } from "react";
import { Autocomplete, Avatar, Box, Chip, TextField,Tooltip } from "@mui/material";
import AddCircleIcon from '@mui/icons-material/AddCircle';
import { renderAlert } from "../../../../CommonComponents/Alert/Alert";
import { extractValueForShareableRollupList, findDefaultItem, generateListDataForRollupStatus, getDefaultNewValue } from "../../helper/helperFunctions";
import { addInitialsToListData, getInitials, parsePersonColValue,parsePersonListData,formatAssigneeValue} from "../../helper/helpersSubModule";
import store from "../../../../redux/store";
import AddOptionPopover from "./AddOptionPopover";
import { useSelector } from "react-redux";
import PropTypes from 'prop-types';

export const CustomDropdownEditor = ({ params, updateDB, updateListData, isEditRowPopup, onClose }) => {
    let { userData } = store.getState().userReducer
    let { allxSpacesUsers } = useSelector((state) => state.gridReducer);
    let { value, api, colDef, onValueChange, eGridCell, eventKey, column, node } = params;
        if (value !== "" && value !== null && value !== undefined && (colDef.type === "person" || colDef.type === "Assignee")) {
            value = formatAssigneeValue(value);
        } else if (colDef.type === "shareableRollupList") {
            value = !value? '':extractValueForShareableRollupList(value);
        }else if(!value) {
        value=''
    }
    else{
        value=value;
    }
    const addnew = "addNewButton";
    const [selectedValues, setSelectedValues] = useState(null);
    let parsedRollupStatusData = null;
    let originalParsedRollupStatusData = null;
    if (colDef.type === "shareableRollupList" ) {
        parsedRollupStatusData = JSON.parse(colDef.listData);
        originalParsedRollupStatusData = JSON.parse(colDef.listData);
        // Find the default status item
     if(!colDef.azureColumn){
        const defaultStatusIndex = parsedRollupStatusData.findIndex(
            opt =>
                typeof opt.value === 'string' &&
                opt.rowId === 'None' &&
                opt.parent === 'Default Status'
        );

        if (defaultStatusIndex !== -1) {
            parsedRollupStatusData.splice(defaultStatusIndex, 1);
        }
        if (colDef?.defaultStatus && colDef?.defaultStatus !=='undefined') {
            const defaultStatusObj = typeof colDef.defaultStatus === 'string'
                ? JSON.parse(colDef.defaultStatus)
                : colDef.defaultStatus;
            parsedRollupStatusData.unshift(defaultStatusObj);
        }
        else {
            parsedRollupStatusData.unshift({
                value: 'Backlog',
                parent: 'Default Status',
                precedence: '0:0',
                rowId: 'None',
            });
        }}
    }
    const result = colDef.type === "person" || colDef.type === "Assignee" ?parsePersonListData(colDef.listData):null

      const parsedListData = result ? result.usernames : null;
      const parsedListEmail = result ? result.emails : null; 
    let valueList;
    if (colDef.type === "person" || colDef.type === "Assignee") {
        if(parsedListData !== null){
          valueList = [...parsedListData, addnew];  
        }
        else{
            valueList=[addnew];
        }
        
    }
      if (colDef.type === "shareableRollupList") {
        valueList = [...parsedRollupStatusData];
        
    } else if (colDef.type === "dropdown" || colDef.type === "dropdownsingle") {
        if (colDef.sharedlistInfo && (colDef?.sharedlistInfo?.user_email === userData?.email)) {
            valueList = [...(colDef.listData || []), addnew];
        }
        else if (colDef.sharedlistInfo && (colDef?.sharedlistInfo?.user_email !== userData?.email)) {
            valueList = [...(colDef.listData || [])];
        }
        else {
            valueList = [...(colDef.listData || []), addnew];
        }
    } 

    let isSingle = colDef.type === "dropdownsingle"||colDef.type === "shareableRollupList" || colDef.type === "status" ? true : false;
    const inputRef = useRef(null);
    const [anchorEl, setAnchorEl] = useState(null);
    const [addNewValue, setAddNewValue] = useState("");
    const [highlightedOption, setHighlightedOption] = useState(valueList?.length>0?valueList[0]:null);
    const [inputValue, setInputValue] = useState("");
    const okButtonRef = useRef(null);
    const cancelButtonRef = useRef(null);
    const [isFirstOpen, setIsFirstOpen] = useState(true);
    const [email, setEmail] = useState('');
    const [usedInitials, setUsedInitials] = useState([]);
    const memoizedUsedInitials = useMemo(() => usedInitials, [usedInitials]);
    let parsedListinitials = (colDef.type === "person" || colDef.type === "Assignee") && colDef?.listData !== null && colDef?.listData !== undefined && colDef?.listData !== ""? JSON.parse(addInitialsToListData(colDef.listData,memoizedUsedInitials)).map(user => user.initials):null;
    const [users, setUsers] = useState(allxSpacesUsers)
    const [typedInitials, setTypedInitials] = useState("");

    let formattedUserData = {
        email: userData?.email,
        username: userData?.name // Rename 'name' to 'username'
    };
    let updatedUsers = [...users, formattedUserData]
    let filteredUpdatedUsers = updatedUsers?.filter(user => {
    // Ensure the user email belongs to the domain @thedigitalgroup.com
    const belongsToDomain = user.email?.endsWith("@thedigitalgroup.com");

    // Check if the user's email is not in the result email list and belongs to the correct domain
    if (belongsToDomain && Array.isArray(result?.emails)) {
        return !result?.emails?.some(resultUser => resultUser === user.email);
    }
    return belongsToDomain; // If result?.emails is not an array, only filter by domain
    });

    const sortUsers = (users) => {
        let tempUsers = users?.slice().sort((a, b) => {
            return a?.username?.localeCompare(b?.username);
        });
        return tempUsers;
    }


    useEffect(() => {
        // 1️⃣ Seed input ONLY once from keyboard typing
        if (eventKey && eventKey.length === 1) {
          setInputValue(eventKey);
        }
        // 2️⃣ Otherwise sync from value (but never JSON)
        else if (isSingle && typeof value === "string") {
          setInputValue(value);
        }
      
        // 3️⃣ Clear invalid values
        if (!value || value === addnew) {
          updateValue("");
          return;
        }
      
        // 4️⃣ Handle shareableRollupList (data only)
        if (colDef.type === "shareableRollupList") {
          const defaultItem = findDefaultItem(
            originalParsedRollupStatusData,
            value
          );
      
          const matchedItem = valueList.find(item => item.value === value);
      
          if (matchedItem) {
            updateValue(
              JSON.stringify({
                rowId: defaultItem?.rowId ?? matchedItem.rowId,
                value: matchedItem.value
              })
            );
          }
      
          return;
        }
      
        // 5️⃣ Normalize stored value WITHOUT touching inputValue
        let newValue;
      
        if (colDef.type === "person" || colDef.type === "Assignee") {
          try {
            newValue = JSON.parse(value).map(user => {
              if (!user?.initials && user.username) {
                return {
                  ...user,
                  initials: getInitials(user, memoizedUsedInitials)
                };
              }
              return user;
            });
          } catch {
            newValue = "";
          }
        } else {
          newValue =
            isEditRowPopup && typeof value === "string" && value.includes(",")
              ? value.split(",")
              : value;
        }
      
        updateValue(newValue);
      }, []);

    // Helper function to format value for DB updates
function formatValueForDB(val, type) {
    if (val === '') {
        return "";
    }
    if (type === "person" || type === "Assignee" ) {
        return JSON.stringify(val);
    }
    if(type === "shareableRollupList"){
        if(typeof value=='string'&& value.startsWith('{')){
            return value
        }
    }
    return val;
}

// Helper function to format value for UI updates
function formatValue(val, type) {
    if (val === '' || val ==='addNewButton') {
        return "";
    }
    if (type === "person" || type === "Assignee") {
        return JSON.stringify(val);
    }
   else return val;
}

const updateValue = (val) => {
    if (!isEditRowPopup) {
        let updatedValue = formatValue(val, colDef.type);
        onValueChange(updatedValue);
    }
    else {
        let dbValue = formatValueForDB(val, colDef.type);
        updateDB(dbValue)
    }
};



    const CustomAutocompleteFilter = (options, { inputValue }) => {
        if (inputValue === undefined || inputValue ==='') {
            setIsFirstOpen(true)
            if (
                !options?.includes('addNewButton') &&
                colDef.type !== "shareableRollupList" &&
                (!colDef?.sharedlistInfo || colDef.sharedlistInfo?.user_email === userData?.email)
            ) {
                options?.push('addNewButton');
            }
            return options;
        }
        else if (inputValue !== "") {
            setIsFirstOpen(true);
            return options?.filter((option) => {
                if (typeof option === 'string') {
                    return option.toLowerCase().includes(inputValue?.toLowerCase()) ||
                        option.toLowerCase() === "addnewbutton";
                }

                if (typeof option === 'object' && option !== null) {
                    return option.value?.toLowerCase().includes(inputValue?.toLowerCase());
                }
                return false;
            });
        }
        else {
            setIsFirstOpen(false)
              return options;
        } 
    };
  
    const handleChange = (e, newValue) => {

        if (newValue === null) {
            newValue = getDefaultNewValue(newValue, colDef, isSingle, originalParsedRollupStatusData,isEditRowPopup);
        }
        if (Array.isArray(newValue) && newValue.includes(addnew)) {
            setAnchorEl(inputRef.current);
            setAddNewValue(inputValue)
            const updatedValue = isSingle ? "" : newValue.filter(item => (item !== addnew) && item !=="").join("⊗⇔≈");
         if (updatedValue !== null && updatedValue !== undefined && updatedValue !== "" && (colDef.type !== "person" && colDef.type !== "Assignee"))   updateValue(updatedValue);
        } else {
            let uniqueOptions;
            if (colDef.type === "person" || colDef.type === "Assignee") {
                let parseValue = JSON.parse(addInitialsToListData(colDef.listData,memoizedUsedInitials))
                const selectedOptions = newValue.flatMap(item => {
                    if (typeof item === 'string') {
                        if (item.startsWith('[{')) {
                            try {
                                let parsedItems = JSON.parse(item);
                                return Array.isArray(parsedItems) ? parsedItems : [parsedItems];
                            } catch (error) {
                                console.error("JSON parsing error:", { error, item });
                                return [];
                            }
                        } else {
                            return parseValue.filter(option => option.username === item);
                        }
                    } else if (Array.isArray(item)) {
                        // If item is an array, flatten it
                        return item;
                    } else {
                        return [item];
                    }
                }).filter(option => option !== undefined);
                uniqueOptions = Array.from(new Map(selectedOptions.map(option => [option.username, option])).values());
            }
            if(newValue === 'addNewButton'){
                setAnchorEl(inputRef.current);
            }

            let defaultItem= findDefaultItem(originalParsedRollupStatusData, newValue)
            const updatedValue = isSingle && colDef.type !== "shareableRollupList" ? newValue : colDef.type === "person" || colDef.type === "Assignee" ? uniqueOptions : colDef.type === "shareableRollupList" ?
            { rowId: defaultItem? defaultItem?.rowId:newValue?.rowId, value: newValue?.value } :
                newValue.join("⊗⇔≈");
            setIsFirstOpen(false)
            updateValue(updatedValue);
        }
        if (!isSingle) {
            setInputValue("")
        }
        else {
            let newValueToUse = newValue;

            if (Array.isArray(newValue) && newValue.includes("addNewButton")) {
                newValueToUse = "";
            } else if (colDef.type === "shareableRollupList") {
                newValueToUse = newValue ? JSON.stringify(newValue) : newValue;
            }
            setInputValue(newValueToUse);
            if (isSingle && newValue !== "addNewButton") {
                if (!isEditRowPopup) {
                    params.stopEditing();
                } else {
                    updateDB(newValueToUse);
                }
            }
        }
    };

    const handlePopoverClose = () => {
        setInputValue("")
        setAddNewValue("")
        params.api.setFocusedCell(node.rowIndex, params.api.getAllGridColumns()[params.api.getAllGridColumns()?.indexOf(column)])
        setAnchorEl(null);
    };const validateStatusInput = (inputValue) => {
        // Regex to check if the input is not purely a number
        const regex = /^\d+$/;
        return !regex.test(inputValue);
    };

    const handleAddValue = () => {
        let userArray
        if (addNewValue !== "") {
            let updatedParams = {...params};
            if (valueList.includes(addNewValue)) {
                const isPersonOrAssignee = colDef.type === "person" || colDef.type === "Assignee";
                const isDuplicateEmail = isPersonOrAssignee && parsedListEmail.includes(selectedValues.email);

                if (isDuplicateEmail) {
                    renderAlert("Username already exists", "error", 2000);
                } else {
                    renderAlert("Option already exists", "error", 2000);
                }
                return;
            }
            if (colDef.type === "status") {
                const isString = validateStatusInput(addNewValue);
                if (!isString) {
                    renderAlert("Status value should not be a  number", "error");
                    return;
                }
            }
            if (colDef.type === 'person' || colDef.type === "Assignee") {
                if (email === '') {
                    renderAlert("Email cannot be empty", "error", 2000);

                    return;
                }
                if (email !== '' && parsedListEmail?.includes(email)) {
                    renderAlert("This Email is already present", "error");

                    return;
                }

                // Regular expression for basic email validation
                const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
                if (!emailPattern.test(email)) {
                    renderAlert("Invalid email format", "error", 2000);
                    return;
                }
                // Check if the email belongs to "thedigitalgroup.com" domain
                const domainPattern = /@thedigitalgroup\.com$/;
                if (!domainPattern.test(email)) {
                    renderAlert("Email must belong to 'thedigitalgroup.com' domain", "error", 2000);
                    return;
                }
                let columns = params.api.getAllGridColumns()
                if (email && addNewValue) {
                    let user = {
                        username: addNewValue,
                        email: email,
                        initials: typedInitials
                    }
                    userArray = [user];
                    updateDB(JSON.stringify(userArray));
                    updateValue(userArray)
                }
            }
            let options
            if (colDef.type === "person" || colDef.type === "Assignee") {

                const newUser = { username: addNewValue, email: email,initials: typedInitials };
                options = [...JSON.parse(params.colDef.listData || '[]'), newUser];
                updatedParams.colDef.listData = JSON.stringify(options);
                //updateValue(JSON.stringify(userArray));
            }
            else {
                options = [...params.colDef.listData];
                options.push(addNewValue);
                updatedParams.colDef.listData = options;
            }     
            if(colDef.type !== 'person' && colDef.type !== 'Assignee') {
                if(colDef.type === 'dropdown' && addNewValue){
                    setAddNewValue(updatedParams.value + '⊗⇔≈' +addNewValue)
                    updateDB(updatedParams.value + '⊗⇔≈' +addNewValue, updatedParams);
                    updateValue(updatedParams.value + '⊗⇔≈' +addNewValue)
                }else{
                    updateDB(addNewValue, updatedParams);
                    updateValue(addNewValue)    
                }
        }
            updateListData(updatedParams);
            handlePopoverClose();
            renderAlert("New option added!", "success", 2000);
            setAddNewValue("");
            setEmail("")
        } else {
            setAddNewValue("");
            setEmail("")
            renderAlert("Please enter a valid value", "error", 2000);
        }
        params.api.setFocusedCell(node.rowIndex+1, params.api.getAllGridColumns()[params.api.getAllGridColumns()?.indexOf(column)])
    };

    const handleKeyDown = (e) => {
        if (e.key === "Tab" || e.key === "Enter") {
            e.preventDefault();
            const valueArray = value.split(',');
            if (highlightedOption && !valueArray.includes(highlightedOption)) {
                isSingle ? handleChange(e, highlightedOption) : handleChange(e, [value, highlightedOption]);
            }
            else if(e.key === "Tab"){
                let columns = params.api.getAllGridColumns()
                let currentColumnIndex = columns.indexOf(column)
                let nextColumn = columns[currentColumnIndex + 1]
                if( nextColumn){ params.api.clearRangeSelection()
                    params.api.setFocusedCell(node.rowIndex, nextColumn)}
                else{
                    params.api.clearRangeSelection()
                    params.api.stopEditing();
                    params.api.setFocusedCell(node.rowIndex, columns[currentColumnIndex])
                }
            }
            else if(e.key === "Enter"){
                let columns = params.api.getAllGridColumns()
                let currentColumnIndex = columns.indexOf(column)
                let Column = columns[currentColumnIndex]
                params.api.clearRangeSelection()
                if (!isEditRowPopup) {
                    if (node.rowIndex + 1) params.api.setFocusedCell(node.rowIndex + 1, Column)
                    else params.api.setFocusedCell(node.rowIndex, Column)
                }
            }
        }
    }  
    
    const getColumnWidth = () => {
        const column = isEditRowPopup ? api.getColumn(params.colDef.colId) : api.getColumn(params.column.colId);
        return column.actualWidth;
    };
   
    const groupByFunction = (option) => {
        return option.parent;
    };

    const getOptionLabelFunction = (option) => {
        if (typeof option === "object" && option?.value) return option.value;
        if (typeof option === "string") return option;
        return "";
    };
    
    let formattedValue;

    if (isSingle) {
        formattedValue = value;
    } else if (colDef.type === "person" || colDef.type === "Assignee") {
        formattedValue = parsePersonColValue(value, memoizedUsedInitials, params.colDef.type)?.map(person => person.username);
    } else if (colDef.type === "shareableRollupList") {
        if (typeof value === 'string') {
            formattedValue = value;
        } else if (typeof value === 'object') {
            formattedValue = value?.value;
        } else {
            formattedValue = JSON.parse(value).value;
        }
    } else if (value && typeof value === 'string') {
        formattedValue = value.includes("⊗⇔≈") 
            ? value.split("⊗⇔≈").filter(item => item !== "") 
            : value?.split(", ").filter(item => item !== "");
    } else {
        formattedValue = [];
    }
  return (
        <Box ref={inputRef}>
            <Autocomplete
                onClose={()=>{if(isEditRowPopup)onClose()}}
                autoHighlight={!isSingle?(isFirstOpen?true:false):true}
                multiple={!isSingle}
                value={formattedValue}                
                disableCloseOnSelect={isSingle ? false : true}
                filterSelectedOptions={true}
                disablePortal={true}
                options={valueList}
                groupBy={groupByFunction}
                getOptionLabel={getOptionLabelFunction}
                renderGroup={(params) => (
                  <li key={params.key} className="groupItem">
                      <div
                          className={params.group?`groupTitle`:''}
                      >
                          {params.group}
                      </div>
                      <ul className="groupList">{params.children}</ul>
                  </li>
                )}
               onChange={handleChange}
                onKeyDown={handleKeyDown}
                filterOptions={CustomAutocompleteFilter}
                inputValue={inputValue}
                onHighlightChange={(event, option, reason) => {
                    setIsFirstOpen(true)
                    setHighlightedOption(option);
                }}
                onInputChange={(event, value, reason) => {
                    if (reason === "input") {
                        setInputValue(value);
                    }
                }}
                forcePopupIcon={"hidden"}
                openOnFocus={!isEditRowPopup?true:false}
                renderTags={(tagValue, getTagProps) => (
                  <div style={{ display: "flex", alignItems: "center", flexDirection: "row", flexWrap: "wrap", width: "fit-content" }}>
                      { tagValue !=undefined && tagValue?.map((option, index) => {
                          // Ensure `option` is an object
                          if (option === addnew) return null;
                          return (
                              <div key={index} style={{ overflowY: 'auto', maxHeight: '94px', margin: '2px' }}>
                                  {/* <Tooltip title={email}> */}
                                  <Chip
                                      size="small"
                                      sx={{
                                          background: "transparent",
                                          fontSize: "11px",
                                          border: "2px solid #bdbdbd",
                                          borderLeft: `2px solid ${isSingle ? "#0871a4" : "#6adc99"}`,
                                          borderRight: `2px solid ${isSingle ? "#0871a4" : "#6adc99"}`,
                                          borderRadius: "1rem",
                                          height: "fit-content",
                                          display: 'flex',
                                          alignItems: 'center',
                                          gap:'0.25rem',
                                          padding: colDef.type === 'person' || colDef.type === "Assignee" ? '2px !important' : '0px',
                                          '& .css-19imqg1': {
                                              padding: colDef.type === 'person' || colDef.type === "Assignee" ? '0px !important' : '0px 2px 0px 5px'
                                          }

                                      }}
                                      variant="outlined"
                                      label={
                                          colDef.type === "person" || colDef.type === "Assignee" ? (
                                              <div style={{ display: 'flex', alignItems: 'center'}}>
                                                  <Avatar
                                                      sx={{
                                                          width: 20,
                                                          height: 20,
                                                          fontSize: '8px',
                                                          padding: '5px',
                                                          bgcolor: 'primary.main',
                                                          marginRight: '4px',
                                                      }}
                                                  >
                                                      {index !== -1 && parsedListinitials!=null && parsedListinitials!=undefined ? parsedListinitials[parsedListData.indexOf(option)] : ''}
                                                  </Avatar>
                                                  <div>{option}</div>
                                              </div>
                                          ) : (
                                              <div style={{ fontSize: '11px' }}>{option}</div>
                                          )
                                      }
                                      {...getTagProps({ index })}
                                  />
                                  {/* </Tooltip> */}
                              </div>
                          );
                      })}
                  </div>
              )}
                renderInput={(params) => <TextField autoFocus={true} size={"small"} InputProps={{ sx: { fontSize: '12px' } }} sx={{ width: "100%" }} {...params} />}
                renderOption={(props, option, index) => {
                    if (option === addnew && !isEditRowPopup && !(colDef.template && !colDef?.azureColumn && colDef.type !== "Assignee")) {
                        return (
                            <li key="addButton" {...props} style={{ display: 'flex', alignItems: 'center', padding: "0px 13px", position: "relative", bottom: 0, width: "100%" }}>
                                <div className="AddOptionButton" style={{ display: "flex", alignItems: "center", gap: "0.5rem", fontSize: "12px" }} >
                                    <AddCircleIcon style={{ fontSize: '1.5rem', color: "#134157", cursor: "pointer" }} />
                                    Add New
                                </div>
                            </li>
                        )
                    } else  if ( option!==addnew ) {
                        const columnWidth = getColumnWidth();  // Get dynamic column width
                        const width = Math.max(260, columnWidth);
                        const maxChars = Math.floor(width / 8); 
                        const truncatedOption = option?.length > maxChars 
                            ? `${option.slice(0, maxChars - 3)}...` 
                            : option;
                        if (colDef.type === "person" || colDef.type === "Assignee") {
                            const index = parsedListData?.indexOf(option);
                            const email = index !== -1  && parsedListEmail ? parsedListEmail[index] : '';
        
                          
                            return (
                                <li {...props} style={{ display: 'flex' }}>
                                    <Tooltip title={email} placement="left"> <div style={{ fontSize: '12px',display: 'flex', gap: '5px', alignItems: 'center' }}>  <Avatar sx={{ width: 20, height: 20, fontSize: '8px', bgcolor: 'primary.main',padding:'5px' }}>
                                    {index !== -1 ? parsedListinitials[index] : ''}
                                    </Avatar> <span className="dropDown-options">{truncatedOption} </span> </div>
                                    </Tooltip> </li>
                            )
                        }
                        else if (colDef.type === 'shareableRollupList') {
                            const isDefaultStatus = option?.parent?.toLowerCase() === 'default status'

                            let defaultItem
                            if (isDefaultStatus) {
                                defaultItem = findDefaultItem(originalParsedRollupStatusData, option)
                            }
                            return (
                                <li
                                    {...props}
                                    style={{
                                        display: 'flex',
                                        marginLeft: '10px',
                                        color: 'inherit',
                                        fontStyle: 'normal',
                                         pointerEvents: 'auto',
                                        opacity: 1
                                    }}
                                > 
                                    <div className="dropDown-options">{ isDefaultStatus && defaultItem ?`${option.value} (Parent: ${defaultItem.parent})` :option.value}</div>
                                </li>
                            )
                        }
                        else {
                            return (
                                <li {...props} style={{ display: 'flex' }}>
                                    <div className="dropDown-options" >{truncatedOption}</div>
                                </li>
                            )
                        }
                    }
                }}
                size="small"
                sx={{
                    background: "white",
                    minWidth: "150px",
                    width: isEditRowPopup?"100%":getColumnWidth() + 'px',
                    maxWidth:isEditRowPopup?"100%": getColumnWidth() + 'px',
                    height: "auto",
                    padding: 0,
                    "& .MuiOutlinedInput-root.MuiInputBase-sizeSmall": {
                        minHeight:isEditRowPopup?'40px': eGridCell.clientHeight + "px",
                        fontSize: "12px",paddingRight:'9px !important'
                    },
              }}
              popperprops={{
                  modifiers: [
                      {
                          name: "preventOverflow",
                          options: {
                              boundary: "window", 
                              altAxis: true,
                              altBoundary: true,
                              tether: true,
                          },
                      },
                      {
                          name: "flip",
                          options: {
                              fallbackPlacements: ["top", "bottom", "right", "left"], 
                          },
                      },
                  ],
              }}
              slotProps={{
                  popper: {
                      placement: "bottom-start",
                      sx: {
                          minWidth: "260px",
                          "& .MuiAutocomplete-listbox": {
                              display: "block",
                              maxHeight: "300px", 
                              minWidth: "260px", 
                              overflowY: "auto", 
                              overflowX: "auto", 
                              whiteSpace: "nowrap", 
                              "& > li": {
                                  display: "block",
                                  minWidth: "260px",
                              },
                              "& .MuiAutocomplete-option": {
                                  overflow: "visible !important", 
                                  whiteSpace: "nowrap", 
                                  maxWidth: "100%", 
                              },
                          },
                      },
                  },
              }}
          />
          {<AddOptionPopover
              anchorEl={anchorEl}
              handlePopoverClose={handlePopoverClose}
              colDef={colDef}
              addNewValue={addNewValue}
              setAddNewValue={setAddNewValue}
              updatedUsers={filteredUpdatedUsers}
              email={email}
              setEmail={setEmail}
              handleAddValue={handleAddValue}
              okButtonRef={okButtonRef}
              cancelButtonRef={cancelButtonRef}
              sortUsers={sortUsers}
              memoizedUsedInitials={memoizedUsedInitials}
              selectedValues={selectedValues}
              setSelectedValues={setSelectedValues}
              setTypedInitials={setTypedInitials}
              typedInitials={typedInitials}
          />}
      </Box>
  );
};

// ✅ Add propTypes validation
CustomDropdownEditor.propTypes = {
    params: PropTypes.shape({
        value: PropTypes.any, // Adjust based on the expected value type
        api: PropTypes.object, // API object from ag-Grid
        colDef: PropTypes.shape({
            type: PropTypes.string.isRequired, // Ensures 'type' is a required string
        }).isRequired, // Ensures 'colDef' is a required object
        onValueChange: PropTypes.func, // Function for handling value changes
        eGridCell: PropTypes.object, // Represents the cell DOM element
        eventKey: PropTypes.oneOfType([PropTypes.string, PropTypes.number]), // Can be a string or number
        column: PropTypes.object, // ag-Grid column object
        node: PropTypes.object, // ag-Grid row node object
    }).isRequired, // Ensures 'params' is a required object
    updateDB: PropTypes.func, // Function to update the database
    updateListData: PropTypes.func, // Function to update list data
    isEditRowPopup: PropTypes.bool, // Boolean flag for popup mode
    onClose: PropTypes.func, // Function for closing the editor
};

// ✅ Add defaultProps to avoid undefined errors
CustomDropdownEditor.defaultProps = {
    updateDB: () => {}, // Default to a no-op function
    updateListData: () => {}, // Default to a no-op function
    isEditRowPopup: false, // Default to false
    onClose: () => {}, // Default to a no-op function
};

export default CustomDropdownEditor;